import cx from 'classnames'

import { controlClassName } from './controlStyles'

export const Input = ({ className, type = 'text', ...props }) => {
  if (type === 'select') {
    return <select className={cx(controlClassName, 'tw:appearance-none tw:pr-8', className)} {...props} />
  }

  if (type === 'textarea') {
    return <textarea className={cx(controlClassName, 'tw:h-auto tw:min-h-28 tw:resize-y', className)} {...props} />
  }

  if (type === 'checkbox') {
    return <input className={cx('ds-checkbox', className)} type="checkbox" {...props} />
  }

  if (type === 'radio') {
    return <input className={cx('tw:h-[18px] tw:w-[18px] tw:accent-action', className)} type="radio" {...props} />
  }

  return <input className={cx(controlClassName, className)} type={type} {...props} />
}
